"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MVPAlt1Combobox = exports.MVPAlt1FieldControl = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../javascript/Utilities");
const PropertyPageControls_1 = require("../../PropertyPage/PropertyPageControls");
class MVPAlt1MultiValueCollection {
    constructor() {
        this.allControls = [];
    }
    pushControl(control) {
        this.allControls.push(control);
    }
}
class MVPAlt1Control {
    constructor(prependId, options) {
        this.id = prependId.replace(/\./g, "_");
        this.options = options;
    }
    getDOMControl() {
        return $("#" + this.id);
    }
    getCurrentValue() {
    }
    getValue() {
        return undefined;
    }
    getInputControl() {
        return $();
    }
    init(jQueryElem) {
        this.initJQueryElem = jQueryElem;
    }
    IsReadOnly() {
        return this.options.readOnly;
    }
    enable(enable) {
    }
}
class MVPAlt1FieldControl extends MVPAlt1Control {
    constructor(prependId, options) {
        super(prependId, options);
        this.multiValues = new MVPAlt1MultiValueCollection();
    }
    notifyChange(ignore = false) {
        let that = this;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        that.controljQueryElem = $("<div id='" + that.id + "_mvalt1widget' class='mvpalt1widget'/>").appendTo(jQueryElem);
    }
    removeMultivalueInput(control) {
        let that = this;
        let pos = -1;
        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
            if (that.multiValues.allControls[i] === control)
                pos = i;
        }
        if (pos !== -1)
            that.multiValues.allControls.splice(pos, 1);
        if (control.container)
            control.container.remove();
    }
    destroy() {
        if ($("#" + this.id).data("kendoToolTip"))
            $("#" + this.id).data("kendoToolTip").destroy();
    }
    enable(enable) {
        super.enable(enable);
        if (this.multiValues.allControls) {
            $.each(this.multiValues.allControls, (idx, mvControl) => {
                mvControl.enableControlButton(enable);
            });
        }
    }
    setValue(value) {
    }
}
exports.MVPAlt1FieldControl = MVPAlt1FieldControl;
class MVPAlt1MVableControl extends MVPAlt1FieldControl {
    constructor(prependId, options, currentMV = undefined) {
        super(prependId, options);
        this.isMultiValueControl = false;
        this.currentMV = currentMV;
        if (currentMV != undefined)
            this.isMultiValueControl = true;
    }
    init(jQueryElem) {
        let that = this;
        if (this.isMultiValueControl) {
            jQueryElem.show(); // Nun sicherstellen, dass auch der Container angezeigt wird - nun darf er Platz durch das Padding verbrauchen
            that.container = $("<div id='" + that.id + "_fieldcontainer' class='mvpalt1fieldcontainer mvpalt1mvfieldcontainer'/>").appendTo(jQueryElem);
        }
        else {
            super.init(jQueryElem);
            that.multivalueContainer = $("<div id='" + that.id + "_mvfieldcontainer' class='mvpalt1mvfieldcontainer' style='box-sizing:border-box;'/>").appendTo(that.controljQueryElem);
            that.multivalueContainer.hide(); // Diesen Container aber nicht anzeigen, da er ansonsten durch sein Padding Platz verbraucht
            that.container = $("<div id='" + that.id + "_fieldcontainer' class='mvpalt1fieldcontainer' />").appendTo(that.controljQueryElem);
        }
        that.controlContainer = $("<div id='" + that.id + "_controlcontainer' class='mvpalt1mvcontrolcontainer' style='box-sizing:border-box;'/>").appendTo(that.container);
        let buttonContainer = $("<div id='" + that.id + "_buttoncontainer' class='mvpalt1buttoncontainer' style='box-sizing:border-box;display:table-cell;width:2.5em;vertical-align: middle;text-align:center'/>").appendTo(that.container);
        let mvWarningToolTip = Utilities_1.synUtil.Strings.getValue("dynpmvalt1italadded", "Value already added");
        that.infoButton = $("<i id='" + that.id + "_warning' class='fa fa-exclamation-triangle' aria-hidden='true' style='box-sizing:border-box;' title='" + mvWarningToolTip + "'></i>").appendTo(buttonContainer);
        that.infoButton.hide();
        that.controlButton = $("<i id='" + that.id + "_button' class='fa' aria-hidden='true' style='box-sizing:border-box;'></i>").appendTo(buttonContainer);
        if (that.isMultiValueControl)
            that.controlButton.addClass("fa-times");
        else {
            that.controlButton.addClass("fa-plus");
            that.controlButton.hide();
        }
        if (that.IsReadOnly())
            that.controlButton.hide();
    }
    getHeight() {
        let that = this;
        let iReturn = 0;
        if (that.controlContainer)
            iReturn = that.controlContainer.height();
        return iReturn;
    }
    enableControlButton(enable) {
        if (this.controlButton) {
            if (enable)
                this.controlButton.show();
            else
                this.controlButton.hide();
        }
    }
    enable(enable) {
        super.enable(enable);
        if (!this.isMultiValueControl && this.controlButton) {
            if (enable) {
                let value = this.getCurrentValue();
                if (value)
                    this.setButtonVisibility(value);
                else
                    this.controlButton.hide();
            }
            else
                this.controlButton.hide();
        }
    }
    setButtonVisibility(value) {
        let that = this;
        let bButtonVisible = false;
        let bInfoButtonVisible = false;
        let entryAlreadExist = false;
        if ((value) && (value.id)) {
            let valueSingle = { id: undefined, value: undefined };
            if (Array.isArray(value.id)) {
                if (value.id.length === 1) {
                    valueSingle.id = value.id[0];
                    valueSingle.value = value.value[0];
                }
            }
            else
                valueSingle = value;
            if ((valueSingle) && (valueSingle.id) && (valueSingle.id !== "")) {
                for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                    if (valueSingle.id === that.multiValues.allControls[i].getCurrentValue().id)
                        entryAlreadExist = true;
                }
                if (!entryAlreadExist && !that.IsReadOnly())
                    bButtonVisible = true;
                else if (entryAlreadExist && !that.IsReadOnly())
                    bInfoButtonVisible = true;
                else {
                    bButtonVisible = false;
                    bInfoButtonVisible = false;
                }
            }
            else
                bButtonVisible = false;
        }
        if (bButtonVisible)
            that.controlButton.show();
        else
            that.controlButton.hide();
        if (bInfoButtonVisible)
            that.infoButton.show();
        else
            that.infoButton.hide();
    }
    notifyChange() {
        super.notifyChange();
        this.setMVContainerVisibilty();
    }
    setMVContainerVisibilty() {
        if (this.isMultiValueControl) {
            if (this.container.children().length > 0)
                this.container.css("display", "block");
            else
                this.container.css("display", "none");
        }
        else {
            if (this.multivalueContainer.children().length > 0)
                this.multivalueContainer.css("display", "block");
            else
                this.multivalueContainer.css("display", "none");
        }
    }
    addMultiValue(value) {
    }
    setMultiValue(value) {
        let that = this;
        $.each(that.multiValues.allControls, (idx, controlToDelete) => {
            controlToDelete.container.remove();
        });
        that.multiValues.allControls.splice(0);
        that.addMultiValue(value);
    }
}
class MVPAlt1Combobox extends MVPAlt1MVableControl {
    constructor(parentDialog, prependId, options, rootControl = undefined, mvValue = undefined) {
        super(prependId, options, mvValue);
        this.parentDialog = parentDialog;
        this.rootControl = rootControl;
        this.buttonControlDef = $.extend(true, this.options.buttonControlDef, {
            forExternalInput: true
        });
        this.controlColl = options.controlColl;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        let controlType = "FTComboBoxInfo";
        let templateForControls = {
            type: controlType,
            enabled: true,
            visible: true,
            visibleDynamic: true,
            key: that.options.controlKey,
            width: 0,
            height: 22,
            tabOrder: 0,
            field: that.options.input.field,
            maxTextLength: that.options.input.maxTextLength,
            readonly: false,
            initialValue: undefined,
            formatString: that.options.input.formatString,
            hardDeletedFormatString: that.options.input.hardDeletedFormatString,
            forExternalInput: true,
        };
        let guid = Utilities_1.synUtil.getGUID(true);
        let createControl = () => {
            let bFirst = true;
            let currentInstance = that.options.currentInstance.clone();
            currentInstance.items[that.options.input.field.presentedField].value = [];
            currentInstance.items[that.options.input.field.fieldName].value = [];
            if (that.currentMV) {
                currentInstance.items[that.options.input.field.presentedField].value = [that.currentMV.id];
                currentInstance.items[that.options.input.field.fieldName].value = [that.currentMV.value];
            }
            that.controlFactory = new PropertyPageControls_1.ControlFactory(that.controlContainer, currentInstance, that.options.typeId, that.options.mode, undefined, {}, undefined);
            that.controlFactory.onFtFieldChange = function (changedInstance) {
                if (that.options.input.field.presentedField) {
                    let idInstance = changedInstance.items[that.options.input.field.presentedField];
                    let valueInstance = changedInstance.items[that.options.input.field.fieldName];
                    if ((idInstance) && (valueInstance)) {
                        let value = {
                            id: idInstance.value,
                            value: valueInstance.value
                        };
                        if ((value.id) && (value.value)) {
                            that.setButtonVisibility(value);
                            if (!that.isMultiValueControl) {
                                if (that.controlButton.is(":visible"))
                                    that.controlButton.trigger("click"); // damit sofort bei der Auswahl eines Eintrages eine neue Zeile eingeblendet wird
                            }
                        }
                    }
                }
            };
            that.controlFactory.onFtDataBound = function (e, changedInstance) {
                // onFtDataBound ist ein Hack, um das folgende Problem des FTComboBoxControl zu umgehen:
                // Wenn das Control das erste mal aufgebaut wird, dann wird beim ERSTEN Aufklappen der Combobox-Liste sofort der erste
                // Eintrag ausgewählt, ABER der onFtFieldChange NICHT ausgelöst. Auf Anraten von cf wurde der onFtDataBound-Event an dieser Stelle
                // eingebaut.
                // Wie gesagt tritt das Problem aber NUR beim ersten Mal auf --> deshalb an dieser Stelle die Abfrage if (bFirst) ...
                if (bFirst) {
                    bFirst = false;
                    if (that.options.input.field.presentedField) {
                        let ValueCurrent = that.getCurrentValue();
                        if ((ValueCurrent.id) && (ValueCurrent.value))
                            that.setButtonVisibility(ValueCurrent);
                    }
                }
            };
            that.controlFactory.pushControl(templateForControls);
            let methodsOnlyFTOL = [];
            if (that.controlColl.Button) {
                let buttonCopy = $.extend(true, {}, that.controlColl.Button);
                for (let xMethod = 0; xMethod < buttonCopy.methods.length; xMethod++) {
                    if (buttonCopy.methods[xMethod].id !== "cefunc.249") {
                        // Die externe Eingabe darf sich nicht selber wieder aufrufen können
                        if ((buttonCopy.methods[xMethod].isFTOLMethod) || (!that.isMultiValueControl)) {
                            // Bei der untersten editierbaren Combobox werden auch externe Eingaben angeboten.
                            // Ansonsten nur FTOL-Methoden.
                            methodsOnlyFTOL.push(buttonCopy.methods[xMethod]);
                        }
                    }
                }
                if (methodsOnlyFTOL.length > 0) {
                    buttonCopy.methods = methodsOnlyFTOL;
                    buttonCopy.text = "";
                    let docId = methodsOnlyFTOL[0]["icon"];
                    let iconName = "";
                    if ((docId !== "") && (docId !== "0"))
                        iconName = "docid=" + docId;
                    else
                        iconName = "resource=icon_externvalues";
                    buttonCopy.buttonIcon = iconName;
                    buttonCopy.desiredHeight = "20px";
                    buttonCopy.desiredWidth = "20px";
                    that.controlFactory.pushControl(buttonCopy);
                }
            }
            that.controlFactory.create();
            that.valueControl = that.controlFactory.controlCollection.allControls[0];
            // Bei der Combobox muss unbedingt ein leerer Eintrag eingefügt werden. Warum?
            // Ansonsten funktionieren FT's mit leeren Einträgen nicht.
            // Die kendo-Combobox hat nämlich folgendes Verhalten:
            // - Verliert die Combobox den Fokus, ohne dass ein Item eingestellt wurde, wird der momentan im Textfeld der Combobox eingestellte Wert genommen und
            //   und ein dazu passender Eintrag automatisch ausgewählt. Wo passiert das? In kendo.combobox.js in _inputFocusout. Hier wird that.text(that.text()) aufgerufen.
            //   Das kann man der kendoCombobox wohl auch nicht abgewöhnen.
            // - Wenn nun das Textfeld leer ist, wird immer ein leerer entry der FT ausgewählt, was aber vom Benutzer absolut nicht gewollt ist.
            // Umgehung des Problems: Es wird immer ein empty entry in der Combobox angeboten. Dieser dient als "victim" für dieses Verhalten der kendoCombobox, indem dieser beim Verlust des Fokus eingestellt wird.
            // Die Applikation kann nun aber diesen empty entry erkennen und ihn ignorieren.
            that.valueControl.addEmptyEntry = PropertyPageControls_1.AddEmptyEntry.Yes;
            if (that.controlFactory.controlCollection.allControls.length > 1) {
                that.buttonControl = that.controlFactory.controlCollection.allControls[1];
                // Die Höhe der Zeile ist erst hier bekannt
                let parentHeight = $(that.controlContainer).height();
                let buttonWidth = parentHeight;
                if (methodsOnlyFTOL.length > 1)
                    buttonWidth = parentHeight * 2;
                that.buttonControl.getDOMControl().width(buttonWidth);
                that.buttonControl.overrideCurrentInstanceIdFuncFTOL = (method, field, docIdCallback) => {
                    let docId;
                    if (field.isFTField) {
                        let id = that.valueControl.getIdString();
                        if (method.field.length > 0) {
                            let ftData = { requestedIds: [id] };
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + field.foreignTableName + "/",
                                requestData: JSON.stringify(ftData),
                                done(data) {
                                    docId = data.items[0][method.field];
                                    docIdCallback(docId);
                                },
                                fail(jqXHR, textStatus, errorThrown, url) {
                                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                }
                            });
                        }
                        else {
                            docId = id;
                            docIdCallback(docId);
                        }
                    }
                };
                that.buttonControl.overrideCurrentInstanceFunc = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let updatededData = yield that.parentDialog.getUpdatedInstanceNoSort();
                    return updatededData.instance;
                });
                that.buttonControl.overrideExternalInputCallBack = (cancelled, changedInstance) => {
                    if ((!cancelled) && (that.parentDialog)) {
                        that.parentDialog.updateDialog(changedInstance);
                    }
                };
                that.valueControl.getDOMControl().css("flex-grow", "1");
            }
            else
                that.valueControl.getDOMControl().css("flex-grow", "1");
            if (that.currentMV)
                that.setValue(that.currentMV);
        };
        createControl();
        if (that.isMultiValueControl) {
            that.controlButton.on("click", function () {
                // remove
                that.rootControl.removeMultivalueInput(that);
                that.rootControl.notifyChange();
                let rootValue = that.rootControl.getCurrentValue();
                if (rootValue != undefined)
                    that.rootControl.setButtonVisibility(rootValue);
                that.parentDialog.adjustDialogHeight();
            });
            that.enable(false);
        }
        else {
            let comboBox = that.valueControl.getDOMControl();
            comboBox.on("keydown", (e) => {
                if (e.keyCode === 13) {
                    if (that.controlButton.is(":visible"))
                        that.controlButton.trigger("click");
                }
            });
            that.controlButton.on("click", function () {
                let val = that.getCurrentValue();
                if (val) {
                    // addchildcontrol
                    that.addMultiValue(val);
                    let emptyValue = { id: "", value: "" };
                    that.setValue(emptyValue);
                    that.valueControl.getInputControl().focus();
                    that.controlButton.hide();
                    that.notifyChange();
                    that.parentDialog.adjustDialogHeight();
                    that.parentDialog.scrollToBottom();
                }
            });
            that.enable(!that.IsReadOnly());
        }
    }
    getHeightContainer() {
        let that = this;
        let iReturn = 0;
        if (that.controljQueryElem)
            iReturn = that.controljQueryElem.height();
        return iReturn;
    }
    getHeightAllItems() {
        let that = this;
        let iHeight = 0;
        if (that.multivalueContainer)
            iHeight = that.multivalueContainer.height();
        if ((that.container) && (!that.parentDialog.IsReadOnly()))
            iHeight = iHeight + that.container.height();
        return iHeight;
    }
    remove() {
        let that = this;
        if (that.controljQueryElem) {
            that.controljQueryElem.remove();
            that.controljQueryElem = undefined;
        }
    }
    getInputControl() {
        return $("#" + this.id);
    }
    getCurrentValue() {
        let that = this;
        if (that.valueControl) {
            let idString = "";
            let valueString = "";
            let id = that.valueControl.getIdString();
            if (id) {
                idString = id;
                let valueArray = that.valueControl.getValue();
                if (valueArray) {
                    if (Array.isArray(valueArray)) {
                        if (valueArray.length === 1)
                            valueString = valueArray[0];
                    }
                    else
                        valueString = valueArray;
                }
            }
            return {
                id: idString,
                value: valueString
            };
        }
        else
            return undefined;
    }
    getValue() {
        let that = this;
        let values = [];
        if (!that.isMultiValueControl) {
            let multivalues = that.getMultiValue();
            if (multivalues) {
                multivalues.forEach((item) => {
                    values.push(item);
                });
            }
            let valueCur = that.getCurrentValue();
            if ((valueCur) && (valueCur.id !== ""))
                values.push(valueCur);
        }
        else {
            let valueCur = that.getCurrentValue();
            if ((valueCur) && (valueCur.id !== ""))
                values.push(valueCur);
        }
        return values;
    }
    getMultiValue() {
        let values = [];
        for (let i = 0; i < this.multiValues.allControls.length; ++i)
            values.push(this.multiValues.allControls[i].getCurrentValue());
        if (values.length > 0)
            return values;
        else
            return undefined;
    }
    addMultiValue(value) {
        let that = this;
        if (value) {
            if (value instanceof Array) {
                $.each(value, (idx, val) => {
                    let bAdd = true;
                    for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                        if (that.multiValues.allControls[i].getCurrentValue().id === val.id)
                            bAdd = false;
                    }
                    if (bAdd) {
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let multiValInput = new MVPAlt1Combobox(that.parentDialog, that.id + "_input_" + guid, that.options, that, { id: val.id, value: val.value });
                        multiValInput.init(that.multivalueContainer);
                        that.multiValues.pushControl(multiValInput);
                    }
                });
            }
            else {
                let bAdd = true;
                for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                    if (that.multiValues.allControls[i].getCurrentValue().id === value.id)
                        bAdd = false;
                }
                if (bAdd) {
                    let guid = Utilities_1.synUtil.getGUID(true);
                    let multiValInput = new MVPAlt1Combobox(that.parentDialog, that.id + "_input_" + guid, that.options, that, { id: value.id, value: value.value });
                    multiValInput.init(that.multivalueContainer);
                    that.multiValues.pushControl(multiValInput);
                }
            }
        }
    }
    setValue(value) {
        let that = this;
        if (that.valueControl) {
            let instance = that.controlFactory.instance;
            instance.items[that.options.input.field.presentedField].value = [];
            instance.items[that.options.input.field.fieldName].value = [];
            if ((value) && (value.id) && (value.id !== "")) {
                instance.items[that.options.input.field.presentedField].value = [value.id];
                instance.items[that.options.input.field.fieldName].value = [value.value];
            }
            that.controlFactory.setNewInstance(instance);
            let comboBox = that.valueControl.getDOMControl();
            // Hack!
            // Die folgenden Properties gehen leider verloren, da das Control bei setValue neu aufgebaut wird!
            // --> Diese müssen neu gesetzt werden!
            comboBox.css("flex-grow", "1");
            comboBox.on("keydown", (e) => {
                if (e.keyCode === 13) {
                    if (that.controlButton.is(":visible"))
                        that.controlButton.trigger("click");
                }
            });
        }
    }
    enable(enable) {
        super.enable(enable);
        enable = enable && !this.options.readOnly;
        this.valueControl.enable(enable);
    }
}
exports.MVPAlt1Combobox = MVPAlt1Combobox;
